export const getTypeFromSchema = (schema: any): string => {
	if (schema?.name) {
		return schema?.name.replace(/const/g, "");
	}
	return null;
};
